import https from '@sg/utils/httpC';
import type { IUserPermissionResponse } from '@sg/types/permission';

/**
 * Get the latest data time for specified modules
 * @param modules - Array of module names
 * @param studio_id - Optional studio ID (required for studios_revenue/studios_profit/studios_note modules)
 * @param project_id - Optional single project ID
 * @param project_ids - Optional project ID list (e.g. InDev ALL view)
 */
export interface GetDataTimeParams {
  modules: string[];
  studio_id?: string;
  project_id?: number;
  project_ids?: number[]; // ALL view sends every GameSelect project id.
}

export interface GetDataTimeResponse {
  data: {
    max_datatime?: string; // Format: "YYYY-MM"
    start_date?: string; // Format: "YYYY-MM" or "YYYY-MM-DD"
    end_date?: string; // Format: "YYYY-MM" or "YYYY-MM-DD"
  };
  code: number;
  msg: string;
}

export const getDataTime = (payload: GetDataTimeParams): Promise<any> => https({
  url: '/api/v1/mgmt_pc/datatime/get',
  method: 'post',
  data: payload,
  rawData: true,
});

// User list API
export const getUserList = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/user_list',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getUserPermission = (
  payload: Record<string, never> = {},
): Promise<IUserPermissionResponse> => https({
  url: '/api/v1/mgmt_pc/permission/user_permission',
  method: 'post',
  data: payload,
  rawData: true,
}) as Promise<IUserPermissionResponse>;

